export default "__VITE_ASSET__CDp4IXwL__"